// =============================================================================
// SITE CONFIGURATION — Le Jean Bart (Montrouge)
// =============================================================================
// Master configuration for Le Jean Bart bar, brasserie & restaurant website.
// Controls styling, localization, reservations, SEO, and integrations.
// =============================================================================

import type { SiteConfig } from '@webzite/content-schema';

const siteConfig: SiteConfig = {
  // =========================================================================
  // VISUAL STYLE
  // =========================================================================
  // Le Jean Bart style pack — authentic Montrouge neighborhood bar & brasserie
  // (crimson awning red, curved copper zinc bar, terracotta brick, and tavern brass).
  stylePack: 'le-jean-bart',

  // =========================================================================
  // GEOGRAPHIC REGION
  // =========================================================================
  // European Union — EU-14 allergen regulations, GDPR cookie consent.
  region: 'eu',

  // =========================================================================
  // LANGUAGE & LOCALIZATION
  // =========================================================================
  defaultLocale: 'fr',
  locales: ['fr', 'en', 'zh', 'de', 'it', 'pt'],
  currency: 'EUR',

  // =========================================================================
  // RESERVATIONS
  // =========================================================================
  reservations: {
    enabled: true,
    provider: 'custom',
    bookingUrl: 'tel:+33174341621',
  },

  // =========================================================================
  // DELIVERY PLATFORMS
  // =========================================================================
  delivery: {
    enabled: false,
    platforms: [],
  },

  // =========================================================================
  // MAP
  // =========================================================================
  maps: {
    provider: 'osm',
    embedUrl:
      'https://www.openstreetmap.org/export/embed.html?bbox=2.3110,48.8100,2.3210,48.8150&layer=mapnik&marker=48.8129148,2.3160239',
    googleMapsLink:
      'https://www.google.com/maps/place/Le+Jean+Bart/@48.8129148,2.3160239,17z/data=!3m1!4b1!4m6!3m5!1s0x47e670fe5c7d0d77:0x7754c70f656f723f!8m2!3d48.8129148!4d2.3160239!16s%2Fg%2F1tdlglxl!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MDkwMi4wIKXMDSoASAFQAw%3D%3D',
    appleMapsLink:
      'https://maps.apple.com/?q=Le+Jean+Bart+134+Avenue+de+la+Republique+92120+Montrouge',
  },

  // =========================================================================
  // ANALYTICS
  // =========================================================================
  analytics: {
    cloudflare: { enabled: true },
    ga4: {
      enabled: false,
      measurementId: '',
    },
  },

  // =========================================================================
  // SEO (Search Engine Optimization)
  // =========================================================================
  seo: {
    titleTemplate: '%s | Le Jean Bart — Bar, Brasserie & Cuisine Traditionnelle · Montrouge',
    defaultDescription:
      'Bistrot-brasserie convivial au 134 Av. de la République, Montrouge. Cuisine maison, spécialité couscous, plat du jour frais, terrasse animée et happy hour.',
    ogImage: '/images/og-image.png',
  },

  // =========================================================================
  // DEVELOPER ATTRIBUTION & WATERMARK
  // =========================================================================
  developer: {
    name: 'jeduapf',
    url: 'https://portfolio.jeduapf.com',
    role: 'Restaurant Web Developer',
    showFooterCredit: true,
  },

  // =========================================================================
  // ALLERGEN REGULATION
  // =========================================================================
  allergenRegulation: 'eu-fic-1169',
};

export default siteConfig;
